import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, Select, useToast, Checkbox, Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { jwtDecode } from "jwt-decode";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { StudentInfo } from '../Common/types';
import { toUtcISOString, parseUtc, fmtLocal } from "../../utils/dates";
import { useTenant } from "../Routers/TenantContextProvider";

interface Tenant {
  tenant_id: number;
  name: string;
  description: string;
  is_active: boolean;
}

// Define the expected structure of the token payload
interface TokenPayload {
  sub: string;       // Typically the username or user ID
  role_id: number;   // Role ID
  tenant_id: number; // Tenant ID
  exp?: number;      // Expiration timestamp (optional)
}



const StudentManager = () => {
  const [studentInfos, setStudentInfos] = useState<StudentInfo[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);
  const navigate = useNavigate();

  const toast = useToast();
  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

  const { tenant, loading, error } = useTenant();

  // Function to get tenant_id from the token
  const getTenantIdFromToken = (token: string): number | null => {
    try {
      const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
      return decoded.tenant_id || null;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };

  // Set tenant ID on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tenantId = getTenantIdFromToken(token);
      console.log("Tenant ID:", tenantId);
      setSelectedTenant(tenantId);
    }
  }, []);

  // Fetch students when tenant ID is set
  useEffect(() => {
    if (selectedTenant) {
      fetchStudentInfos();
    }
  }, [selectedTenant]);

  const fetchStudentInfos = async () => {
    if (!selectedTenant) return;
    try {
      const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
      const response = await axios.get(`${tenantsapiurl}/${selectedTenant}/students`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setStudentInfos(response.data);
    } catch (error) {
      console.error("Failed to load students", error);
    }
  };

  const handleReviewStudent = (student_id: number) => {
    // Placeholder function
 //   navigate(`/coaching/admin/dashboard/student-manager/review-student/${student_id}`);

    if (tenant)
    {
      navigate(`/platform/${tenant.tenant_slug}/app/student-manager/review-student/${student_id}`);
    }
  };

  return (
    <Box as="main" mx="auto" p={10} >
      <VStack>
        <Heading size={"md"}>All Registered Students</Heading>
      </VStack>

      <Box mt={4}>
        <Text fontWeight="bold">Students Details</Text>
        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead fontSize="12">
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Name</Th>
              <Th>Gender</Th>
              <Th>DoB</Th>
              <Th>Email</Th>
              <Th>Address</Th>
              <Th>Grade</Th>
              <Th>School</Th>
              <Th>User Id</Th>
              <Th>Created At</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="12">
            {studentInfos.map((studentInfo) => (
              <Tr key={studentInfo.student_id}>
                <Td>{studentInfo.student_id}</Td>
                <Td>{`${studentInfo.givenName} ${studentInfo.middlename} ${studentInfo.surname}`}</Td>
                <Td>{`${studentInfo.gender}`}</Td>
                <Td>
                    {studentInfo.dateOfBirth 
                        ? new Date(studentInfo.dateOfBirth).toLocaleDateString() 
                        : 'N/A'}
                    </Td>
                <Td>{`${studentInfo.email}`}</Td>
                <Td>{`${studentInfo.address} ${studentInfo.suburb} ${studentInfo.postcode}`}</Td>
                <Td>{`${studentInfo.schoolGrade}`}</Td>
                <Td>{`${studentInfo.schoolName}`}</Td>
                <Td>{`${studentInfo.user_id}`}</Td>
      
                <Td>{fmtLocal(studentInfo.created_at)}</Td>
                <Td>
                  <Tooltip label="Edit">
                    <Button size="sm" onClick={() => handleReviewStudent(studentInfo.student_id)}>
                      Review Student
                    </Button>
                  </Tooltip>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default StudentManager;
